import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Facebook, Youtube, Mail, Phone, ExternalLink } from "lucide-react";

const CONTACTS = [
  {
    label: "Facebook",
    value: "facebook.com/Charge.zenekar",
    href: "https://www.facebook.com/Charge.zenekar/",
    icon: Facebook,
    accent: "#00E5FF",
    testid: "contact-facebook",
  },
  {
    label: "YouTube",
    value: "@charge4797",
    href: "https://www.youtube.com/@charge4797",
    icon: Youtube,
    accent: "#FF007F",
    testid: "contact-youtube",
  },
  {
    label: "Email",
    value: "simkojana@gmail.com",
    href: "mailto:simkojana@gmail.com",
    icon: Mail,
    accent: "#7000FF",
    testid: "contact-email",
  },
  {
    label: "Telefon",
    value: "06 70 533 6029",
    href: "tel:+36705336029",
    icon: Phone,
    accent: "#00E5FF",
    testid: "contact-phone",
  },
];

export const ContactsDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#0A0A0A] border-white/10 text-white max-w-lg p-0 overflow-hidden"
        data-testid="contacts-dialog"
      >
        {/* Top accent bar */}
        <div className="h-1 w-full bg-gradient-to-r from-[#00E5FF] via-[#7000FF] to-[#FF007F]" />

        <div className="p-8">
          <DialogHeader className="text-left">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/hoz25lwc_Charge%20Charlie%20Cover%20Band.webp"
                alt="CHARGE logo"
                className="h-10 w-10 object-contain"
              />
              <p className="font-display text-xs tracking-[0.4em] uppercase text-[#00E5FF]">
                // Lépj kapcsolatba
              </p>
            </div>
            <DialogTitle className="font-display text-3xl font-bold tracking-tight text-white">
              Elérhetőségek
            </DialogTitle>
            <DialogDescription className="font-body text-white/50 mt-2">
              Foglalás, kérdés vagy üzenet — válaszd a számodra legkényelmesebb módot.
            </DialogDescription>
          </DialogHeader>

          <div className="mt-8 space-y-3">
            {CONTACTS.map(({ label, value, href, icon: Icon, accent, testid }) => (
              <a
                key={label}
                href={href}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                data-testid={testid}
                className="group flex items-center gap-4 p-4 border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/20 transition-all duration-300"
              >
                <div
                  className="flex h-11 w-11 items-center justify-center border"
                  style={{
                    color: accent,
                    borderColor: `${accent}60`,
                    backgroundColor: `${accent}15`,
                  }}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-display text-[0.65rem] uppercase tracking-[0.3em] text-white/40">
                    {label}
                  </p>
                  <p className="font-body text-sm text-white truncate">{value}</p>
                </div>
                <ExternalLink className="h-4 w-4 text-white/30 group-hover:text-white transition-colors" />
              </a>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactsDialog;
